import { Backdrop } from "@mui/material";
import React, { useState } from "react";
import useLogic from "./Logic/useLogic";
import SuggestionList from "./components/SuggestionList/SuggestionList";

const SuggestionBackdrop = ({
  openBackdrop,
  setUiValue,
  element,
  setSuggestion,
  onChange,
}) => {
  const [forceRender, setForceRender] = useState(false);
  const { backdrop, setBackdrop } = useLogic(openBackdrop);

  return (
    <React.Fragment>
      {forceRender ? <></> : <React.Fragment></React.Fragment>}
      {backdrop ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={!!backdrop}
          onClick={() => {
            setBackdrop(false);
            setSuggestion(false);
          }}
        >
          <SuggestionList
            setUiValue={setUiValue}
            element={element}
            setForceRender={setForceRender}
            forceRender={forceRender}
            onChange={onChange}
          />
        </Backdrop>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
};

export default SuggestionBackdrop;
